import { render } from "./SwipperCard.vue?vue&type=template&id=6fbc5aaa"
import script from "./SwipperCard.vue?vue&type=script&lang=js"
export * from "./SwipperCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__